import styled from 'styled-components'

export const AnotationText = styled.div`
  font-size: 16px;
  line-height: 190%;

  @media screen and (max-width: 1047px) {
    font-size: 15px;
    line-height: 180%;
  }
`
